import { Component, Vue, Prop } from "vue-property-decorator";
import UserDiscover from "@/components/UserDiscover/UserDiscover.vue";
import ItemSelector from "@/components/ItemSelector/ItemSelector.vue";

class LoginRouterSteps {
  public static readonly UserDiscover = "UserDiscover";
  public static readonly TenantSelector = "TenantSelector";
  public static readonly Redirecting = "Redirecting";
}

@Component({
  components: {
    UserDiscover,
    ItemSelector
  }
})
export default class LoginRouter extends Vue {
  private StepType = LoginRouterSteps;
  private userTenants: Array<any> = [];
  private currentStemp = LoginRouterSteps.UserDiscover;

  private isCurrentStep(step: string): boolean {
    return step === this.currentStemp;
  }

  public updateTenants(tenants: Array<any>) {
    if (tenants.length === 1) {
      this.tenantSelected(tenants[0]);
      return;
    }

    this.userTenants = tenants;
    this.currentStemp = this.StepType.TenantSelector;
  }
  public tenantSelected(tenant: any) {
    this.currentStemp = this.StepType.Redirecting;
    window.location.href = tenant.authUrl;
  }
}
